<template>
  <div>
    <div class="d-flex align-center">
      <page-title value="発達記録" />
    </div>
    <child-developments-container />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import PageTitle from "@/components/atoms/PageTitle.vue";
import ChildDevelopmentsContainer from "@/containers/child-development/ChildDevelopmentsContainer.vue";

export default defineComponent({
  components: {
    PageTitle,
    ChildDevelopmentsContainer,
  },
});
</script>
